import React from 'react';

function MyBox() {
  window.location.href = 'https://scholar.google.co.in/citations?user=MWM26BoAAAAJ&hl=en';
  return (
    <div>
      Redirecting to Pritha's publications ...
    </div>
  );
}

export default MyBox;